import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { FormatoMensagem } from '../../model/formatomensagem';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-formatomensagem',
  templateUrl: './formatomensagem.component.html',
  styleUrls: ['./formatomensagem.component.scss']
})
export class FormatoMensagemComponent implements OnInit {

  movSub: Subscription;
  formatomensagem: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getformatomensagems();
  }

  async getformatomensagems(){

    this.formatomensagem = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("formatomensagem/list").subscribe(
        (result: any) =>{

          this.formatomensagem =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novoformatomensagem(){
    this.modalService.modalDetalhesFormatoMensagem.emit(null);
  }

  editar(formatomensagem: FormatoMensagem){
    this.modalService.modalDetalhesFormatoMensagem.emit(formatomensagem);
  }

  excluir(formatomensagem: FormatoMensagem){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("formatomensagem/delete", formatomensagem).subscribe(
            (result) =>{

              this.toastr.success('Formato de Mensagem excluído com sucesso!', 'Sucesso!');
              this.getformatomensagems();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
